// assets/recently-viewed-custom.js
(function () {
  var STORAGE_KEY = 'recently_viewed_products';

  // --- HTMLエスケープ ----------------------------------
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // --- localStorage ヘルパー ---------------------------
  function getList() {
    if (!window.localStorage) return [];
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      return arr;
    } catch (e) {
      return [];
    }
  }

  function saveList(arr) {
    if (!window.localStorage) return;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      // 容量オーバーなどは無視
    }
  }

  function addHandle(handle) {
    if (!handle) return;

    var list = getList().filter(function (h) {
      return h !== handle;
    });

    // 先頭に追加
    list.unshift(handle);

    // 最大 20 件くらいに制限
    list = list.slice(0, 20);

    saveList(list);
  }

  // --- 閲覧履歴を記録（product ページでのみ） --------
  function recordCurrentProduct() {
    // theme.liquid で埋め込んだ変数を読む
    var handle = window.__recentlyViewedHandle;
    if (!handle) return;
    addHandle(handle);
  }

  // --- 価格表示をなるべく安全に整形 -------------------
  function formatPriceJpy(cents) {
    if (!cents || isNaN(cents)) return '';
    try {
      var num = Number(cents) / 100;
      return '¥' + num.toLocaleString('ja-JP', { maximumFractionDigits: 0 });
    } catch (e) {
      return '¥' + Math.round(Number(cents) / 100);
    }
  }

  // --- セクションへ出力 -------------------------------
  function renderRecentlyViewed() {
    var sections = document.querySelectorAll(
      '[data-section-type="recently-viewed"]'
    );
    if (!sections.length) return;

    var list = getList();

    sections.forEach(function (section) {
      var container = section.querySelector('[id^="RecentlyViewed-"]');
      if (!container) return;

      var sectionId = section.getAttribute('data-section-id') || 'recent';
      var currentHandle = section.getAttribute('data-product-handle') || null;
      var max = parseInt(
        section.getAttribute('data-recent-count') || '4',
        10
      );

      // Liquid 側で data-grid-item-class にグリッド用クラスを入れている
      var gridClass = section.getAttribute('data-grid-item-class') || '';

      // card-product の設定類
      var cardStyle =
        section.getAttribute('data-card-style') || 'standard';
      var cardColorScheme =
        section.getAttribute('data-card-color-scheme') || 'background-1';
      var badgePosition =
        section.getAttribute('data-badge-position') || 'bottom left';
      var soldOutBadgeColor =
        section.getAttribute('data-sold-out-badge-color') ||
        cardColorScheme;
      var saleBadgeColor =
        section.getAttribute('data-sale-badge-color') ||
        cardColorScheme;
      var textSoldOut =
        section.getAttribute('data-text-sold-out') || 'Sold out';
      var textOnSale =
        section.getAttribute('data-text-on-sale') || 'On sale';

      // 今見ている商品（currentHandle）は除外しつつ、上限まで
      var handles = list
        .filter(function (h) {
          return h && h !== currentHandle;
        })
        .slice(0, max);

      if (!handles.length) {
        // 何もないときはセクションごと非表示
        section.style.display = 'none';
        return;
      }

      // Shopify のルート（多言語対応している場合などのため）
      var root =
        (window.Shopify &&
          Shopify.routes &&
          Shopify.routes.root) ||
        '/';

      handles.forEach(function (handle) {
        fetch(root + 'products/' + handle + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('Network error');
            return res.json();
          })
          .then(function (product) {
            if (!product) return;

            var item = document.createElement('div');
            // grid__item などのクラスをそのまま適用
            item.className = gridClass;

            // URL（なければハンドルから組み立て）
            var productUrl =
              product.url || (root + 'products/' + product.handle);

            // 画像URL
            var imageUrl = '';
            if (product.featured_image) {
              if (typeof product.featured_image === 'string') {
                imageUrl = product.featured_image;
              } else if (product.featured_image.src) {
                imageUrl = product.featured_image.src;
              }
            } else if (product.images && product.images.length) {
              imageUrl =
                typeof product.images[0] === 'string'
                  ? product.images[0]
                  : product.images[0].src || '';
            }

            // 価格
            var price = Number(product.price) || 0;
            var comparePrice = Number(product.compare_at_price) || 0;

            var priceHtml = '';
            if (price > 0) {
              if (comparePrice > price) {
                priceHtml =
                  '<div class="price price--on-sale">' +
                  '  <span class="price-item price-item--regular price-item--compare">' +
                  escapeHtml(formatPriceJpy(comparePrice)) +
                  '</span>' +
                  '  <span class="price-item price-item--sale price-item--last">' +
                  escapeHtml(formatPriceJpy(price)) +
                  '</span>' +
                  '</div>';
              } else {
                priceHtml =
                  '<div class="price">' +
                  '  <span class="price-item price-item--regular price-item--last">' +
                  escapeHtml(formatPriceJpy(price)) +
                  '</span>' +
                  '</div>';
              }
            }

            // バッジ
            var badgeSpan = '';
            var isAvailable =
              typeof product.available === 'boolean'
                ? product.available
                : true;

            if (!isAvailable) {
              badgeSpan =
                '<span class="badge badge--bottom-left color-' +
                escapeHtml(soldOutBadgeColor) +
                '">' +
                escapeHtml(textSoldOut) +
                '</span>';
            } else if (comparePrice > price && price > 0) {
              badgeSpan =
                '<span class="badge badge--bottom-left color-' +
                escapeHtml(saleBadgeColor) +
                '">' +
                escapeHtml(textOnSale) +
                '</span>';
            }

            var badgeContainer =
              '<div class="card__badge ' +
              escapeHtml(badgePosition) +
              '">' +
              badgeSpan +
              '</div>';

            // card-product と同じ 2段構成
            var cardClasses =
              'card card--' +
              escapeHtml(cardStyle) +
              ' card--media';
            if (cardStyle === 'card') {
              cardClasses +=
                ' color-' + escapeHtml(cardColorScheme) + ' gradient';
            }

            var innerClasses = 'card__inner';
            if (cardStyle === 'standard') {
              innerClasses +=
                ' color-' + escapeHtml(cardColorScheme) + ' gradient';
            }
            innerClasses += ' ratio';

            var titleIdBase =
              sectionId + '-' + (product.id || product.handle);

            item.innerHTML =
              '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
              '  <div class="' +
              cardClasses +
              '" style="--ratio-percent: 100%;">' +
              '    <div class="' +
              innerClasses +
              '" style="--ratio-percent: 100%;">' +
              (imageUrl
                ? '      <div class="card__media">' +
                  '        <div class="media media--transparent media--hover-effect">' +
                  '          <img src="' +
                  imageUrl +
                  '" alt="' +
                  escapeHtml(product.title || '') +
                  '" loading="lazy" class="motion-reduce" />' +
                  '        </div>' +
                  '      </div>'
                : '') +
              // ▼ card__inner 内側の card__content（オーバーレイ側）
              '      <div class="card__content">' +
              '        <div class="card__information">' +
              '          <h3 class="card__heading" id="title-' +
              titleIdBase +
              '">' +
              '            <a href="' +
              productUrl +
              '" id="StandardCardNoMediaLink-' +
              titleIdBase +
              '" class="full-unstyled-link">' +
              escapeHtml(product.title || '') +
              '</a>' +
              '          </h3>' +
              '        </div>' +
              '        ' +
              badgeContainer +
              '      </div>' +
              '    </div>' +
              // ▼ 外側の card__content（本体情報側）
              '    <div class="card__content">' +
              '      <div class="card__information">' +
              '        <h3 class="card__heading h5" id="CardLink-' +
              titleIdBase +
              '">' +
              '          <a href="' +
              productUrl +
              '" id="CardLink-' +
              titleIdBase +
              '" class="full-unstyled-link">' +
              escapeHtml(product.title || '') +
              '</a>' +
              '        </h3>' +
              '        <div class="card-information">' +
              priceHtml +
              '        </div>' +
              '      </div>' +
              '      ' +
              badgeContainer +
              '    </div>' +
              '  </div>' +
              '</div>';

            container.appendChild(item);
          })
          .catch(function (err) {
            if (window.console && console.warn) {
              console.warn('recently viewed error', err);
            }
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 1. product ページなら閲覧履歴に追加
    recordCurrentProduct();

    // 2. TOP などに置いた recently-viewed セクションに商品を描画
    renderRecentlyViewed();
  });
})();